import type { RGBA } from "models-webgl2";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type BackgroundComponentState = {
  opacity: number;
  color: RGBA;
};

export class BackgroundComponent extends Webgl2Component<undefined, BackgroundComponentState> {
  constructor(color: RGBA, opacity = 1) {
    super({ opacity, color });
  }

  public getRenderData() {
    const material = Webgl2.materials.backgroundColor;
    material.setUniforms({
      u_opacity: this.state.opacity,
      u_color: this.state.color,
    });
    return { material };
  }
}

export default BackgroundComponent;
